export const FEEDBACK_SUBMISSION = 'FEEDBACK_SUBMISSION';